const translation = {
  title: '탐색',
  sidebar: {
    discovery: '탐색',
    chat: '채팅',
    workspace: '작업 공간',
    action: {
      pin: '고정',
      unpin: '고정 해제',
      rename: '이름 변경',
      delete: '삭제',
    },
    delete: {
      title: '앱 삭제',
      content: '이 앱을 삭제해도 괜찮습니까?',
    },
  },
  apps: {
    title: 'Dify 로 앱 탐색',
    description: '이 템플릿 앱을 즉시 사용하거나 템플릿을 기반으로 고유한 앱을 사용자 정의하세요.',
    allCategories: '모든 카테고리',
  },
  appCard: {
    addToWorkspace: '작업 공간에 추가',
    customize: '사용자 정의',
  },
  appCustomize: {
    title: '{{name}}으로 앱 만들기',
    subTitle: '앱 아이콘 및 이름',
    nameRequired: '앱 이름은 필수입니다',
  },
  category: {
    Assistant: '어시스턴트',
    Writing: '작성',
    Translate: '번역',
    Programming: '프로그래밍',
    Agent: '에이전트',
    Workflow: '워크플로우',
    HR: '인사',
    Entertainment: '오락',
  },
}

export default translation
